import React, { Component } from 'react';
import styles from './styles.module.css';

import CrossIcon from '../../icons/Cross';
import ChevronIcon from '../../icons/Chevron';

import Checkbox from '../Checkbox';
import Tooltip from '../Tooltip';

const SearchOption = ({ type, id, label, value, onChange }) => (
  <li className={styles.searchOption}>
    <label
      htmlFor={id}
      onClick={event => {
        event.preventDefault();
        onChange(event);
      }}
    >
      <Checkbox
        color="#282c34"
        type={type}
        id={id}
        value={value}
        onChange={onChange}
      />
      <span>{label}</span>
    </label>
  </li>
);

export default class SearchFilter extends Component {
  constructor() {
    super();
    this.state = {
      open: true,
      openHeight: null
    };
  }

  componentDidMount() {
    setTimeout(
      () =>
        this.setState({
          open: document.body.clientWidth >= 1024,
          openHeight: this.listElement.offsetHeight + 2
        }),
      500
    );
  }

  render() {
    const { title, amountSelected, clearAll, filters } = this.props;
    const { open, openHeight } = this.state;
    return (
      <div className={`${styles.container} ${open ? styles.open : ''}`}>
        <div className={styles.heading}>
          <button
            className={styles.openButton}
            onClick={() => this.setState({ open: !open })}
          >
            <ChevronIcon color="#282c34" />
          </button>
          <span className={styles.title}>
            {title}
            {amountSelected > 0 && ` (${amountSelected})`}
          </span>
          {amountSelected > 0 && (
            <Tooltip text="Clear all">
              <button onClick={clearAll}>
                <CrossIcon color="#282c34" />
              </button>
            </Tooltip>
          )}
        </div>
        <div
          className={styles.list}
          style={{
            height: open ? `${openHeight}px` : '0px'
          }}
        >
          <ul
            ref={element => {
              this.listElement = element;
            }}
          >
            {filters
              .sort((a, b) => a.text.localeCompare(b.text))
              .map(({ text, value, onChange }, index) => (
                <SearchOption
                  key={index}
                  type="checkbox"
                  id={this.props.title.replace(/\s/, '') + index}
                  label={text}
                  value={value}
                  onChange={onChange}
                />
              ))}
          </ul>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/search-filter/index.js